// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"034d83d4","190":"b81078b5","787":"41889e1d","863":"61652f9d"}[chunkId] + ".chunk.js";
};